export default {"src":"/_next/static/media/features-third-party-integrations.f2078714.svg","height":59,"width":58,"blurWidth":0,"blurHeight":0};